import { Form } from '@unistocks/components/form/form';
import { oneOf, requiredSchema } from '@unistocks/components/form/validators';
import { PieChartTypeSelect } from '@unistocks/features/dashboard/components/dashboard-data/portfolio-overview/pie-chart-type';
import { PortfolioFilter } from '@unistocks/features/dashboard/components/settings/portfolio-filter';
import { t } from '@unistocks/localization';
import { PieChartType } from '@unistocks/proxy/axios-client';
import { assetTypeOptions } from '@unistocks/shared/utils/enums/asset-type-options';
import { z } from 'zod';

export const portfolioOverviewSchemaFactory = () =>
  z.object({
    title: z.string().nullish(),
    portfolios: z
      .array(z.string())
      .nullish()
      .refine(
        value => value?.length === 1,
        t('::ValidationError:Required:Selection', { 0: t('::Portfolio') })
      ),
    sections: z.array(z.string()).nullish(),
    assetTypes: z.array(oneOf(assetTypeOptions.map(({ value }) => value))).nullish(),
    pieChartSettings: z.object({
      chartType: requiredSchema(
        oneOf([PieChartType.Assets, PieChartType.Categories, PieChartType.CashHoldings]),
        t('::Dashboard:Settings:ChartType')
      )
    })
  });

export const PortfolioOverviewSettings: React.FC = () => {
  return (
    <>
      <Form.Input
        name={'title'}
        label={t('::DisplayName')}
        helpText={t('::Dashboard:Settings:Title:HelpText')}
      />
      <PortfolioFilter
        portfolioSelectOverrides={{ multiple: false }}
        sectionSelectOverrides={{ hidden: true }}
        assetTypeSelectOverrides={{ hidden: true }}
      />
      <PieChartTypeSelect name="pieChartSettings.chartType" />
    </>
  );
};

PortfolioOverviewSettings.displayName = 'PortfolioOverviewSettings';
